import React from "react";
import { FaCalendarTimes, FaTimes } from "react-icons/fa";

const formatDate = (value) => {
  if (!value) return "Not set";
  const [year, month, day] = String(value).slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return "Not set";
  return new Date(year, month - 1, day).toLocaleDateString("en-PH", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export default function SubscriptionExpiredModal({ isOpen, details, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/60 px-4 backdrop-blur-sm">
      <div className="w-full max-w-lg overflow-hidden rounded-[28px] border border-white/20 bg-white shadow-[0_32px_90px_rgba(2,8,23,0.35)]">
        <div className="relative border-b border-slate-100 bg-[linear-gradient(145deg,#fff7f7,#ffffff)] px-6 py-6 sm:px-7">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-slate-900"
            aria-label="Close subscription expired notice"
          >
            <FaTimes />
          </button>

          <div className="flex items-start gap-4 pr-10">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-rose-100 text-xl text-rose-600">
              <FaCalendarTimes />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-rose-500">
                Access paused
              </p>
              <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-950">
                Subscription Expired
              </h2>
              <p className="mt-2 text-sm leading-6 text-slate-500">
                Your credentials were correct, but this customer subscription is no longer active for the current local date.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4 px-6 py-5 sm:px-7">
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
            <div className="flex items-center justify-between gap-4 border-b border-slate-200 pb-3">
              <span className="text-sm text-slate-500">Customer</span>
              <span className="text-right text-sm font-semibold text-slate-900">
                {details?.customer_name || "Customer account"}
              </span>
            </div>
            <div className="mt-3 flex items-center justify-between gap-4">
              <span className="text-sm text-slate-500">Subscription period</span>
              <span className="text-right text-sm font-semibold text-slate-900">
                {formatDate(details?.start_date)} - {formatDate(details?.end_date)}
              </span>
            </div>
            <div className="mt-3 flex items-center justify-between gap-4">
              <span className="text-sm text-slate-500">Current local date</span>
              <span className="text-right text-sm font-semibold text-rose-600">
                {formatDate(details?.local_date)}
              </span>
            </div>
          </div>

          <p className="text-sm leading-6 text-slate-500">
            Please contact ZeroOne IT Inc. to renew the monthly subscription. This login session was stopped automatically.
          </p>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_28px_rgba(15,23,42,0.18)] transition hover:-translate-y-0.5 hover:bg-slate-800 focus:outline-none focus:ring-4 focus:ring-slate-300"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
